import req from "@/axios/index.js";

const baseURL = process.env.VUE_APP_BASE_API;

// ***********新接口****************
// 修改医生视频状态
export function updateVideoStatus (params) {
  return req("post", "doctor/updateVideoStatus", params, { baseURL });
}
// 获取医生信息
export function getDoctorInformation (params) {
  return req("get", "doctor/information", params, { baseURL });
}

// 登录
export function getDoctorToken (data) {
  return req("post", "auth/doctor/token", data, { baseURL });
}

// 患者列表
export function getSickList (params) {
  return req("get", "admin/doctor/order/list", params, { baseURL });
}
// 查看病历
export function caseQueryById (params) {
  return req("get", "admin/doctor/get/patient", params, { baseURL });
}
// export function caseQueryById(params) {
//     return req('get', 'case/getCases', params, { baseURL });
// };
// 患者信息
export function patientsInfo (params) {
  return req("get", "admin/doctor/order/details", params, { baseURL });
}
// 患者详情
export function getHisCase (params) {
  return req("get", "case/getHisCase", params, { baseURL });
}
// 保存患者处方信息
export function saveHisCase (data) {
  return req("post", "case/saveHisCase", data, { baseURL });
}
// 选择疾病
export function getDisease (params) {
  return req("get", "doctor/case/disease/list", params, { baseURL });
}
// 添加药品
export function addDictMap (params) {
  return req("get", "doctor/drugs/dict", params, { baseURL });
}
// 药品列表
export function getDrugList (data) {
  return req("post", "doctor/drugs/queryPage", data);
}
// 结束诊断
export function overDiagnose (params) {
  return req("post", "doctor/order/over", null, { params, baseURL });
}
// 退诊
export function refundOrder (data) {
  return req("post", "doctor/order/refundOrder", data, { baseURL });
}
// 获取举报患者
export function getEvent (params) {
  return req("get", "case/getEvent", params, { baseURL });
}
// 举报患者字典
export function dateTypeDict (params) {
  return req("get", "case/dateTypeDict", params, { baseURL });
}
// 保存信息
export function saveEvent (params) {
  return req("post", "case/saveEvent", params, { baseURL });
}
// 发起双向回护
export function webCall (params) {
  return req("post", "doctor/order/webCall", null, { params, baseURL });
}
// 上报管理列表
export function getEventList (params) {
  return req("get", "case/eventList", params, { baseURL });
}
// 处方列表
export function getPrescriptionList (params) {
  return req("get", "doctor/recipe/list", params, { baseURL });
}
// 处方列表统计接口
export function getPrescriptionCount (params) {
  return req("get", "case/prescriptionCount", params, { baseURL });
}
// 处方列表详情
export function getPrescriptionForm (params) {
  return req("get", "case/prescriptionForm", params, { baseURL });
}
// 上报管理详情
export function getEventForm (params) {
  return req("get", "case/eventForm", params, { baseURL });
}
// 处理加密图片
export function getBaseFile (params) {
  return req("post", "upload/getBaseFile", params, { baseURL });
}
// 退款接口 确认
export function setRefundCancel (params) {
  return req("post", "doctor/order/cancel", null, { params, baseURL });
}
// 获取退款原因
export function getRefundRemark (params) {
  return req("post", "admin/doctor/remark", null, { params, baseURL });
}
// 获取排期接口
export function getSchedule (params) {
  return req("get", "admin/doctor/schedule/template", params, { baseURL });
}
// 查看医生排期
export function getPeriod (params) {
  return req("get", "admin/doctor/period/list", params, { baseURL });
}
// 添加医生排期
export function addSchedule (params) {
  return req("post", "admin/doctor/schedule", params, { baseURL });
}
// 添加医生排期(时间)
export function addPeriod (params) {
  return req("post", "admin/doctor/addPeriod", params, { baseURL });
}
// 修改医生排期(时间)
export function editPeriod (params) {
  return req("post", "doctor/schedule/editPeriod", params, { baseURL });
}
// 删除医生排期
export function delPeriod (params) {
  return req("post", "doctor/schedule/delPeriod", null, { params, baseURL });
}
// 聊天房间号
export function createRoom (params) {
  return req("post", "doctor/av/createRoom", params, { baseURL });
}
// 聊天token
export function getToken (params) {
  return req("get", "doctor/av/getToken", params, { baseURL });
}
// 销毁聊天室
export function deleteRoom (params) {
  return req("get", "doctor/av/deleteRoom", params, { baseURL });
}
// 处方签名
export function prescriptionSign (params) {
  return req("post", "/doctor/recipe/sign?recipeId=" + params.recipeId, params, { baseURL });
}

//服务类型分页查询
export const getServiceList = function (params) {
  return req("get", "admin/doctor/queryList", params, { baseURL });
};

// 获取订单对应的电话录音
export const getVoice = function (params) {
  return req("get", "doctor/order/getVoice", params, { baseURL });
};

// 获取医生常用语
export const getCommonWordsList = function (params) {
  return req("get", "doctor/phrase/list", params, { baseURL });
};

// 添加医生常用语
export const addCommonWords = function (data) {
  return req("post", "doctor/phrase/add", data, { baseURL });
};

// 删除医生常用语
export const deleteCommonWords = function (params) {
  return req("get", "doctor/phrase/remove", params, { baseURL });
};

// 根据id获取常用语
export const getCommonWords = function (params) {
  return req("get", "commonWords/getCommonWords", params, { baseURL });
};
// 修改常用语
export const updateCommonWords = function (params) {
  return req("post", "doctor/phrase/modify", params, { baseURL });
};
// 医生电子签名
export const setSign = function (params) {
  return req("post", "/doctor/sign", params, { baseURL });
};
// 补单新接口
export const savePhone = function (params) {
  return req("post", "/case/savePhone", params, { baseURL });
};
// 补单  更新患者订单
// 补单
export const saveHisCaseSupplement = function (params) {
  return req("post", "case/saveHisCaseSupplement", params, { baseURL });
};
// 医生端查看消息
export const imMsgReacd = function (params) {
  return req("post", "doctor/im/msg/record/read", params, { baseURL });
};
// 提醒用户
export const imMsgRemind = function (params) {
  return req("post", "doctor/im/msg/remind", params, { baseURL });
};
// 修改医生手机号_获取验证码
export const getCaptcha = function (params) {
  return req("post", "doctor/edit/mobile/code", params, { baseURL });
};
// 医生接口-注销接口_获取验证码
export const getLogoffCode = function (params) {
  return req("post", "doctor/logoff/code", params, { baseURL });
};
// 结束问诊时调用将医生和患者的聊天记录生成PDF/MP3/MP4/webm并通过FTP上传监管平台
export const setSuperviseCityPdf = function (params) {
  return req("get", "doctor/im/superviseCityPdf", params, { baseURL });
};
